import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RedirectGuard implements CanActivate {
  public isBrowser: boolean;
  constructor(@Inject(PLATFORM_ID) platformId: any) {
    this.isBrowser = isPlatformBrowser(platformId);
  }
  canActivate() {
    if (this.isBrowser && navigator) {
      if (
        /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        if (
          /HMSCore/i.test(navigator.userAgent) &&
          !/GMS/i.test(navigator.userAgent)
        ) {
          window.location.assign(
            'https://appgallery.huawei.com/#/app/C101565365'
          );
          return true;
        } else {
          window.location.assign(
            'https://play.google.com/store/apps/details?id=com.aktifbank.nkolay'
          );
          return true;
        }
      } else if (/iPhone|iPad|iPod|/i.test(navigator.userAgent)) {
        window.location.assign(
          'https://apps.apple.com/tr/app/n-kolay/id1449491530?l=tr'
        );
        return true;
      } else {
        window.location.assign('/');
        return true;
      }
    }
    return true;
  }
}
